import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, HelpCircle } from 'lucide-react';
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const menuItems = [{
    name: 'Nos services',
    path: '/nos-services'
  }, {

    name: 'Vélos reconditionnés',
    path: '/velos-occasion'
  }, {
    name: 'Professionnels',
    path: '/professionnels'
  }, {
    name: 'Qui sommes-nous',
    path: '/qui-sommes-nous'
  }];
  return <nav className="bg-white/95 backdrop-blur-sm border-b border-border sticky top-0 z-50 shadow-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img src="https://static-us-img.skywork.ai/prod/user/head_picture/2010981800069206016_typo hirondelles cadre vélo noir.png?image_process=quality,q_90/resize,w_1280/format,webp" alt="Les Hirondelles - Location de vélos" className="w-auto transition-transform duration-300 group-hover:scale-105 h-[42px] object-cover" />
          </Link>

          {/* Desktop Menu - Center */}
          <div className="hidden md:flex items-center space-x-1">
            {menuItems.map(item => <Link key={item.path} to={item.path} className={`px-4 py-2.5 rounded-xl text-sm font-medium nav-item transition-all duration-200 ${location.pathname === item.path ? 'bg-primary text-primary-foreground shadow-sm' : 'text-slate-700 hover:text-primary hover:bg-primary/5'}`}>
                {item.name}
              </Link>)}
          </div>

          {/* Action Buttons - Right */}
          <div className="hidden md:flex items-center space-x-3">
            {/* Primary CTA - Réserver un vélo */}
            <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 py-2.5 rounded-xl btn-premium shadow-md hover:shadow-lg transition-all duration-300">
              <Link to="/reserver">Réserver un vélo</Link>
            </Button>
            
            {/* Secondary CTA - Nous contacter */}
            <Button asChild variant="outline" className="border-primary/30 text-primary hover:bg-primary/5 font-medium px-4 py-2.5 rounded-xl hover-glow transition-all duration-300">
              <Link to="/nous-contacter">Nous contacter</Link>
            </Button>
            
            {/* FAQ Button - Circular */}
            <Button 
              asChild 
              className="w-10 h-10 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground p-0 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 flex items-center justify-center"
            >
              <Link to="/faq" title="Questions fréquentes">
                <span className="text-xs font-bold">FAQ</span>
              </Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button variant="ghost" size="sm" onClick={() => setIsOpen(!isOpen)} className="p-2">
              {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && <div className="md:hidden border-t border-border bg-white">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {menuItems.map(item => <Link key={item.path} to={item.path} onClick={() => setIsOpen(false)} className={`block px-3 py-2 rounded-lg text-base font-medium transition-smooth ${location.pathname === item.path ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground hover:bg-muted'}`}>
                  {item.name}
                </Link>)}
              <div className="pt-2 space-y-2">
                {/* Primary CTA Mobile */}
                <Button asChild className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold transition-smooth">
                  <Link to="/reserver" onClick={() => setIsOpen(false)}>
                    Réserver un vélo
                  </Link>
                </Button>
                
                {/* Secondary CTA Mobile */}
                <Button asChild variant="outline" className="w-full border-primary/30 text-primary hover:bg-primary/5 font-medium transition-smooth">
                  <Link to="/nous-contacter" onClick={() => setIsOpen(false)}>
                    Nous contacter
                  </Link>
                </Button>
                
                {/* FAQ Button Mobile */}
                <Button asChild variant="outline" className="w-full border-primary/30 text-primary hover:bg-primary/5 font-medium transition-smooth">
                  <Link to="/faq" onClick={() => setIsOpen(false)}>
                    <HelpCircle className="h-4 w-4 mr-2" />
                    FAQ
                  </Link>
                </Button>
              </div>
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navigation;